<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-10 17:46:42
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 10:43:03
 * @Description: 公告内容
 -->
<template>
  <div class="m-announcement-content-wrapper">
    <h3 class="title">{{ title }}</h3>
    <p class="date">{{ date }}</p>
    <p class="line"></p>
    <div class="html-body" v-html="htmlText" ref="htmlbody"></div>
  </div>
</template>
<script>
export default {
  name: 'announcement-content',
  data() {
    return {
      title: '',
      date: '',
      htmlText: ''
    };
  },
  created() {
    this.requestContent();
  },
  methods: {
    async requestContent() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'pinfo.notice.detail',
        noticeid: this.$route.params.id,
        terminal: 4
      });
      if (res.code === 200) {
        this.title = res.data.title;
        this.date = res.data.issue_time;
        this.htmlText = res.data.body;
      }
    }
  }
};
</script>
<style lang="less">
.m-announcement-content-wrapper {
  padding: 0.2rem;
  font-size: 0.24rem;
  .title {
    text-align: center;
    font-size: 0.28rem;
    line-height: 2;
    color: #666;
    margin-bottom: 0.2rem;
  }
  .date {
    text-align: center;
  }
  .line {
    border-bottom: 0.02rem solid #ccc;
    margin: 0.3rem 0;
  }
  .html-body {
    img {
      width: 90%;
    }
  }
}
</style>
